import { AddIcon, AddIconBlck } from "../../../../assets/icons";
import useAppAccessor from "../../../../hooks/useappAccessor";
import { getBrandColor } from "../../../../utils/brand.util";

const InteractionsHeader = (props: any) => {
  const { getLiveMainData, getControls, getUserData } = useAppAccessor();
  const { language, client } = getUserData();
  const isHost = () => {
    return window.location.href.indexOf("/stream") > -1;
  };


  return (
    <div
      className="flex w-full items-center justify-between px-4 border-b border-[#2A2A2A]"
      style={{
        height: 64,
        backgroundColor: "#1F1F1F",
      }}
    >
      <div className="flex items-center gap-2">
        <h2 className="text-white font-semibold text-base tracking-tight">
          {language["Interactions"]}
        </h2>
      </div>
      {isHost() && (
        <button
          className="flex items-center justify-center rounded-lg cursor-pointer transition-all duration-200 hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl"
          style={{
            height: 40,
            width: 40,
            backgroundColor: getBrandColor(client),
          }}
          onClick={() => {
            props.handleShowOptionsClick();
          }}
          aria-label="Add interaction"
        >
          <img src={AddIconBlck} alt="Add" className="w-5 h-5" />
        </button>
      )}
    </div>
  );
};

export default InteractionsHeader;
